import { log2 } from "../../utils/log2";
import { sendSocketMessage } from "../../utils/socketStream";

const log = log2("webrtc.vuex");
const webrtc = {
    namespaced: true,
    state: {
        videoCallMode: false,
        dialingConversationId: null,
        dialingVisitorId: null,
        calling: false,
        answerTime: null,
        rejectTime: null,
        videoEnabled: true,
        micEnabled: true,
        remoteVideoEnabled: true,
        remoteMicEnabled: true,
        soundOnly: false,
        isScreenSharing: false,
    },
    getters: {
        isCalling: (state) => {
            return state.videoCallMode && state.calling && !state.rejectTime && !state.answerTime;
        },
    },
    mutations: {
        ["SET_VIDEO_ENABLED"](state, payload) {
            state.videoEnabled = payload;
        },
        ["SET_MIC_ENABLED"](state, payload) {
            state.micEnabled = payload;
        },
        ["SET_REMOTE_VIDEO_ENABLED"](state, payload) {
            state.remoteVideoEnabled = payload;
        },
        ["SET_REMOTE_MIC_ENABLED"](state, payload) {
            state.remoteMicEnabled = payload;
        },
        SET_VC_MODE: (state, vcMode) => {
            log("SET_VC_MODE", vcMode);
            state.videoCallMode = vcMode;
        },
        SET_DIALING_CONVERSATION_ID: (state, id) => {
            if (id) log("SET_DIALING_CONVERSATION_ID", id);
            state.dialingConversationId = id;
        },
        SET_DIALING_VISITOR_ID: (state, id) => {
            if (id) log("SET_DIALING_VISITOR_ID", id);
            state.dialingVisitorId = id;
        },
        SET_CALLING: (state, isCalling) => {
            log("calling", isCalling);
            state.calling = isCalling;
        },
        SET_ANSWER: (state, ts) => {
            if (ts) log("vc answered");
            state.answerTime = ts;
            state.calling = false;
        },
        SET_REJECT: (state, ts) => {
            if (ts) log("vc rejected");
            state.rejectTime = ts;
            state.calling = false;
        },
        SET_SOUND_ONLY(state, payload) {
            if (payload) {
                state.soundOnly = payload;
            } else {
                state.soundOnly = false;
            }
        },
        SET_SCREEN_SHARE(state, payload) {
            state.isScreenSharing = payload;
        },
    },
    actions: {
        setVideoEnabled({ commit, state, rootState }, payload) {
            if (!state.soundOnly) {
                commit("SET_VIDEO_ENABLED", payload);
                sendSocketMessage("visitor video-call-toggle", {
                    siteId: rootState.site.site._id,
                    mic: state.micEnabled,
                    video: payload,
                    conversationId: rootState.chat.activeConversation._id,
                });
            }
        },
        setMicEnabled({ commit, state, rootState }, payload) {
            commit("SET_MIC_ENABLED", payload);

            if (rootState.chat.activeConversation) {
                sendSocketMessage("visitor video-call-toggle", {
                    siteId: rootState.site.site._id,
                    mic: payload,
                    video: state.videoEnabled,
                    conversationId: rootState.chat.activeConversation._id,
                });
            }
        },
        setVideoCallMode({ commit }, payload) {
            const { videoCallMode, conversationId, visitorId, soundOnly } = payload;
            commit("SET_VC_MODE", videoCallMode);
            commit("SET_DIALING_CONVERSATION_ID", conversationId);
            commit("SET_DIALING_VISITOR_ID", visitorId);
            commit("SET_SOUND_ONLY", soundOnly);
            if (!soundOnly) {
                commit("SET_REMOTE_VIDEO_ENABLED", true);
            }
            if (videoCallMode) {
                commit("SET_REJECT", null);
                commit("SET_ANSWER", null);
            }
        },
        setCalling({ commit }, isCalling) {
            commit("SET_CALLING", isCalling);
        },
        videoCallRejected({ commit }) {
            commit("SET_REJECT", Date.now());
            commit("SET_ANSWER", null);
            commit("SET_VC_MODE", false);
            commit("SET_DIALING_CONVERSATION_ID", null);
            commit("SET_DIALING_VISITOR_ID", null);
        },
        videoCallAnswered({ commit }) {
            commit("SET_ANSWER", Date.now());
        },
        screenShare({ commit }, isSharing) {
            commit("SET_SCREEN_SHARE", isSharing);
        },
        setSoundOnly({ commit }, soundOnly) {
            commit("SET_SOUND_ONLY", soundOnly);
        },
        closeConnection({ commit }) {
            commit("SET_SOUND_ONLY", false);
            commit("SET_SCREEN_SHARE", false);
            commit("SET_CALLING", false);
            commit("SET_REMOTE_VIDEO_ENABLED", true);
            commit("SET_VIDEO_ENABLED", true);
            commit("SET_MIC_ENABLED", true);
            commit("SET_REMOTE_MIC_ENABLED", true);
        },
    },
};

export default webrtc;
